import React, { useState } from "react";
import { substitutedAddedModifiers } from "../../../helpers/helperMethods";
import ComboItemModifiers from "./ComboItemModifiers";
import { toFixedNumber } from "../../../priceCalculation/helper";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";
interface ICartComboModifiers {
  modifiers: any[];
}

const CartComboModifiers: React.FC<ICartComboModifiers> = ({ modifiers }) => {
  const [showMore, setShowMore] = useState(false);
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  const handleShowMoreOrLess = () => {
    if (showMore) setShowMore(false);
    else setShowMore(true);
  };

  const extraPrice = (modifier) => {
    if(modifier?.price > 0){
      return <span className={`clr-red-dark f-s12 font-Vcf text-end `}>+${toFixedNumber(modifier.price)}</span>
    }
    return null;
  }

  let hasMore = false;
  return (
    <ul className={`list-inline f-s14 font-rale clr-dark-grey text-start mt-md-2 mt-0 position-relative ${isDesignV2 ? 'ps-2 pt-2' : 'ps-0'}`} data-testid="itemModifiersList">
      {modifiers.map((modifier, i: number) => {
        if( !hasMore && modifier?.modifiers?.length > 1 ) hasMore = true;
        return modifier.is_item ? (
          <li className={`f-s14 ${isDesignV2 ? 'font-Visby-cf f-w5 f-s15 ls-05 mb-0' : ''}`} key={i} data-testid="itemModifiersName">
            {modifier.modifier_name}{" "}
            {extraPrice(modifier)}
            <ComboItemModifiers
              modifiers={substitutedAddedModifiers(modifier)}
              paragraphClassName={"f-s14 text-start mb-0"}
              showMore={showMore}
            />
          </li>
        ) : null;
      })}
      {hasMore && (
        <span
          className="cursor-pointer clr-sb-dark"
          onClick={handleShowMoreOrLess}
        >
          {!showMore ? "see more" : "see less"}
        </span>
      )}
    </ul>
  );
};

export default CartComboModifiers;
